<template>
    <div>
        <b-card v-if="this.Type == 'C1'">
          <h3>Calibration Readings</h3>
          <br/>
          <b-card-group deck>
            <b-card class="TwoWideRepeatDash" v-for="(id,idx) in this.ProbeArray" :key="idx"
             header-border-variant="info"
                    header-bg-variant="info"
                    header-text-variant="light">
                    <template #header>
                <b-row><b-col>Probe {{ id.ProbeNo }}</b-col></b-row></template>
           <hr/>
        <b-row><b-col><b>Probe Feed</b></b-col><b-col>{{ id.ProbeFeed }}</b-col></b-row>
        <b-row><b-col><b>Probe Position</b></b-col><b-col>{{ id.ProbePosition }}</b-col></b-row>
        <b-row><b-col><b>Probe Recirculatory</b></b-col><b-col>{{ id.ProbeRecirc}}</b-col></b-row>
        <b-row><b-col><b>Probe Tag</b></b-col><b-col><b-col>{{id.ProbeTag }}</b-col></b-col></b-row>
        <br/>
        <b-row><b-col><b>Calibration Temp</b></b-col><b-col><b-form-input type="number" step="0.50" min="0.00" max="100.00" v-model="id.ProbeTemp" placeholder="00.00"></b-form-input></b-col></b-row>
        <b-row><b-col><b>Calibrate Flow</b> <b-badge pill variant="info"  
            v-b-tooltip.hover title="A minimum flow duration of 30 seconds is recommended to ensure sufficient data quality.">i</b-badge></b-col>
          <b-col> 
      <b-form-select v-model="id.ProbeFlow" :options="FlowOptions" size="sm"></b-form-select></b-col></b-row>
        </b-card>     
        </b-card-group>
        </b-card>
        <b-card v-if="this.Type == 'O1'">
          <h3>Calibration Readings</h3>
          <br/>
          <b-card-group deck>
            <b-card class="TwoWideRepeatDash" v-for="(id,idx) in this.ProbeArray" :key="idx"
             header-border-variant="info"
                    header-bg-variant="info"
                    header-text-variant="light">
                    <template #header>
                <b-row><b-col>Probe {{ id.ProbeNo }}</b-col></b-row></template>
           <hr/>
        <b-row><b-col><b>Probe Feed</b></b-col><b-col>{{ id.ProbeFeed }}</b-col></b-row>
        <b-row><b-col><b>Probe Position</b></b-col><b-col>{{ id.ProbePosition }}</b-col></b-row>
        <b-row><b-col><b>Probe Recirculatory</b></b-col><b-col>{{ id.ProbeRecirc}}</b-col></b-row>
        <b-row><b-col><b>Probe Tag</b></b-col><b-col><b-col>{{id.ProbeTag }}</b-col></b-col></b-row>
               <br/>
        <b-row><b-col><b>Calibration Temp</b></b-col><b-col><b-form-input type="number" step="0.50" min="0.00" max="100.00" v-model="id.ProbeTemp" placeholder="00.00"></b-form-input></b-col></b-row>
        <b-row><b-col><b>Calibration Flow</b> <b-badge pill variant="info"  
            v-b-tooltip.hover title="A minimum flow duration of 30 seconds is recommended to ensure sufficient data quality.">i</b-badge></b-col>
         <b-col>    <b-form-select v-model="id.ProbeFlow" :options="FlowOptions" size="sm"></b-form-select></b-col></b-row>
        </b-card>     
        </b-card-group>
        </b-card>
        <b-row><b-col><b-button variant="outline-success" v-if="stepComplete == false" v-on:click="CompletePage()">Page Complete</b-button></b-col></b-row>
         
    </div>
</template>

<script>
    export default {
      props:['DataPass','Type','ID','Feeds','Positions'],
      data() {
      return {
        stepComplete: false,
        myData: [],
        ProbeArray: [],
        Values: [],
        FlowOptions:[{value: 'TRUE', text: 'True'},{value: 'FALSE', text: 'False'}]
      }
    },
    computed: {},
    components: {},
    methods:{
      CompletePage(){
        let valid = ""
        for(let t=0;t<this.ProbeArray.length;t++){
          if(this.ProbeArray[t].ProbeTemp == "" || this.ProbeArray[t].ProbeFlow == ""){
            alert("Please insert temp and flow options for each probe")
            valid = "false"
          }
          if (this.NumberCheck(this.ProbeArray[t].ProbeTemp) == true){
          alert("Please ensure entries contain only valid numbers")
        }
        }
       

        if (valid != 'false'){
          this.Values.push(this.myData[0])
          this.Values.push(this.myData[1])
          this.Values.push(this.myData[2])
          this.Values.push(this.ProbeArray)
          this.$emit("PageComplete",4,this.Values);
          this.stepComplete = true;
        }
      },
      NumberCheck(data){
  
        this.InvalidNum = false
        
        let invaliddata = /^\d{1,3}(\.\d+)?$/.test(data)

        if (!invaliddata){
          this.InvalidNum = true
        }

        return this.InvalidNum
      }
    },
    mounted(){
      this.myData = this.DataPass
      
      this.ProbeArray = this.myData[3];
    }

    }
</script>

<style>
.TwoWideRepeatDash{
  min-width: 45%; max-width: 100%; margin-bottom: 1rem !important;
}
</style>